import {
  breakpointSizes,
  getBreakpointDown,
  Processing,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface UploadingAttachmentProps {
  className?: string
  imgUrl: string
}

const UploadingAttachment: React.FC<UploadingAttachmentProps> = (
  props,
): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        height: ${styleConstants.elementSize.attachmentThumbnail_smUp};
        width: ${styleConstants.elementSize.attachmentThumbnail_smUp};
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15);
        border-radius: ${styleConstants.borderRadius.button};
        position: relative;
        overflow: hidden;
        ${getBreakpointDown(breakpointSizes.XSM)(css`
          height: ${styleConstants.elementSize.attachmentThumbnail_xsmDown};
          width: ${styleConstants.elementSize.attachmentThumbnail_xsmDown};
        `)}
      `}
    >
      <img
        css={css`
          opacity: 0.25;
          height: ${styleConstants.elementSize.attachmentThumbnail_smUp};
          width: ${styleConstants.elementSize.attachmentThumbnail_smUp};
          ${getBreakpointDown(breakpointSizes.XSM)(css`
            height: ${styleConstants.elementSize.attachmentThumbnail_xsmDown};
            width: ${styleConstants.elementSize.attachmentThumbnail_xsmDown};
          `)}
        `}
        src={props.imgUrl}
        alt={''}
      />
      <div
        css={css`
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        `}
      >
        <Processing />
      </div>
    </div>
  )
}

export default UploadingAttachment
